












import { Vue, Component, Prop } from 'vue-property-decorator';
import { mdbRow, mdbCol, mdbInput, mdbIcon } from '@folky-tools/mdbvue';

@Component({
    components: {
        mdbRow,
        mdbCol,
        mdbInput,
        mdbIcon
    }
})
export default class EditQr extends Vue {
    @Prop(String) private qrUrl?: string;
    @Prop(String) private help?: string;

    get dirtyQrUrl(): string {
        return this.qrUrl!;
    }

    set dirtyQrUrl(value: string) {
        this.$emit('update:qrUrl', value);
    }
}
